import React from 'react';
import styled, { css } from 'styled-components';

import increaseClickableAreaForHtmlElement from 'helpers/increaseClickableAreaForHtmlElement';

import DotIcon from '../icons/DotIcon';

type Props = {
  clickHandler: () => void;
  withBackground?: boolean;
};

const AdvancedButton = ({ clickHandler, withBackground }: Props) => (
  <Container
    $withBackground={withBackground}
    data-testid="dotted-button"
    onClick={clickHandler}
  >
    <DotIcon />
    <DotIcon />
    <DotIcon />
  </Container>
);

const BUTTON_VERTICAL_RANGE = 5;
const BUTTON_HORIZONTAL_RANGE = 5;

const Container = styled.button<{ $withBackground?: boolean }>`
  z-index: 3;
  position: relative;
  display: flex;
  align-items: center;
  width: 20px;
  justify-content: space-between;
  align-self: center;
  margin-left: auto;
  outline: none;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  height: 20px;
  border-radius: 50%;
  ${increaseClickableAreaForHtmlElement(
    BUTTON_VERTICAL_RANGE,
    BUTTON_HORIZONTAL_RANGE
  )}
  ${({ $withBackground }) =>
    $withBackground &&
    css`
      width: 28px;
      height: 28px;
      background: rgba(105 176 199 / 10%);
      padding: 0 7px;
    `}

  svg {
    transition: all 0.4s;

    ${({ $withBackground }) =>
      $withBackground &&
      css`
        width: 3px;
        height: 3px;
      `}
  }

  &:hover {
    svg {
      transform: ${({ $withBackground }) =>
        $withBackground ? 'scale(1.3)' : 'scale(1.5)'};
    }
  }
`;

export default AdvancedButton;
